import DeleteIconButton from 'components/common/delete-icon-button';
import { Input } from 'components/elements';
import { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import { SeparatorVertical } from 'components/styles';
import { CardSection, SeparatorHorizontal } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import ActivityAddOnsTable from './add-ons-table';
import ActivityGuestTable from './guest-table';
import { DetailsCardHeader } from '../../style';
import { ActivityPurchaseFormType } from '../form-type';
import GroupDetailTable from '../group-detail-table';

interface Props {
  parentIndex: number;
  onRemove: () => void;
  fieldLength?: number;
}

export default function Guest(props: Props) {
  const { parentIndex, onRemove, fieldLength } = props;
  const { t } = useTranslation();
  const { editable } = useFormState();
  const name = `activityPurchases.${parentIndex}` as const;
  const { setValue, control } = useFormContext<ActivityPurchaseFormType>();

  const { activityPurchaseGuests } = useWatch({
    control,
    name,
  });

  const onAfterChange = React.useCallback(
    (checked: boolean) => {
      if (activityPurchaseGuests.length > 1) {
        (activityPurchaseGuests || []).map((item, idx) => {
          if (idx !== 0) {
            setValue(
              `activityPurchases.${parentIndex}.activityPurchaseGuests.${idx}`,
              {
                ...item,
                activityPurchaseGuestDetails:
                  activityPurchaseGuests[parentIndex]
                    .activityPurchaseGuestDetails,
              },
              { shouldTouch: true, shouldValidate: true },
            );
          }
        });
      }
    },
    [activityPurchaseGuests, parentIndex, setValue],
  );

  return (
    <CardSection>
      <DetailsCardHeader>
        <Text variant="HeadingXSmall">
          {t('common:other_purchase_detail')} {parentIndex + 1}
        </Text>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Input
            type="check-box"
            name={`activityPurchases.${parentIndex}.isGroupedPrice`}
            label={t('ticketSales:grouped_price')}
            onAfterChange={onAfterChange}
            noMargin
          />
          {(fieldLength || 0) > 1 && editable && (
            <>
              <SeparatorHorizontal $margin={16} />
              <DeleteIconButton
                onClick={onRemove}
                rootStyle={{ height: '32px' }}
              />
            </>
          )}
        </div>
      </DetailsCardHeader>
      <SeparatorVertical $margin={8} />
      <ActivityGuestTable parentIndex={parentIndex} />
      <SeparatorVertical $margin={16} />
      <GroupDetailTable parentIndex={parentIndex} />
      <SeparatorVertical $margin={12} />
      <ActivityAddOnsTable parentIndex={parentIndex} />
    </CardSection>
  );
}
